import { createFileRoute } from '@tanstack/react-router';

import { Button, ButtonGroup } from '@/common/components/button';
import { Heading } from '@/common/components/heading';
import { Text, TextLink } from '@/common/components/text';

export const Route = createFileRoute('/apply/commercial')({
  component: CommercialRoute
});

function CommercialRoute() {
  return (
    <div className="p-8">
      <Heading>Apply for Commercial Service</Heading>

      <Text>We currently aren't accepting commercial applications through this site. We ask that you bring the following information to a Member Services location:</Text>

      <ul className="pl-10 list-disc">
        <li>Tax ID number</li>
        <li>Business name</li>
        <li>Letter of authorization (signed by an officer)</li>
        <li>Meter number</li>
      </ul>

      <Text>You can also apply online by emailing this information to <TextLink href="mailto:memberfeedback@talquinelectric.com">memberfeedback@talquinelectric.com</TextLink>. A Member Services Representative will then contact you and provide an application to be signed and notarized within three business days of your request.</Text>

      <ButtonGroup>
        <Button to="/apply" outline>Back</Button>
      </ButtonGroup>
    </div>
  );
}
